import { Box as HeadlessBox } from '@zillow/constellation-headless/components/box/box';
import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import type { BoxPropsInterface } from './types/box.types';

/**
 * Base component that other components can build on top of to provide
 *  access to the theme and CSS properties.
 *
 * Since v10 we would advocate that you leverage this component over Flex, Grid, and Spacer
 *  as these 3 components will are now deprecated and will be removed in the future.
 *
 * @since 8.83.0
 */

export const Box = forwardRef<HTMLDivElement, BoxPropsInterface>(
  (props: BoxPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;

    const styles = css(cssProp);

    return (
      <HeadlessBox
        ref={forwardedRef}
        className={cx('c11n', 'c11n_box', styles, className)}
        {...rest}
      />
    );
  },
);

Box.displayName = 'Box';
